import React from "react";
import { NavLink } from "react-router-dom";
import { useNexauraData } from "../../context/NexauraContext";

const BASE = [
  { to: "/dashboard", ico: "◈", label: "Home" },
  { to: "/boards", ico: "▦", label: "Boards" },
  { to: "/team", ico: "⛓", label: "Team" },
  { to: "/rewards", ico: "👑", label: "Rewards" },
];

export default function BottomNav() {
  const { data } = useNexauraData();
  const items = [...BASE];
  if (data?.isAdmin) items.push({ to: "/admin", ico: "⚙", label: "Admin" });

  return (
    <nav className="bottom-nav">
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
        >
          <span className="ico">{it.ico}</span>
          {it.label}
        </NavLink>
      ))}
    </nav>
  );
}
